import React, { useEffect, useState } from "react";

/**
 * Hairline gold thread pinned to the top edge of the page that fills as the
 * visitor scrolls. Purely visual, sits above everything at z-60.
 */
export default function ScrollProgressThread() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const on = () => {
      const doc = document.documentElement;
      const max = Math.max(1, doc.scrollHeight - doc.clientHeight);
      const p = Math.min(100, Math.max(0, (window.scrollY / max) * 100));
      setPct(p);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    window.addEventListener("resize", on, { passive: true });
    return () => {
      window.removeEventListener("scroll", on);
      window.removeEventListener("resize", on);
    };
  }, []);
  return <div className="scroll-thread" style={{ "--scroll-progress": `${pct}%` }} aria-hidden="true" data-testid="scroll-thread" />;
}
